import { LiveList, LiveObject, type Lson } from "@liveblocks/client"

export function wrapWithLiveblocksModel(model: unknown): unknown {
  if (model instanceof LiveObject || model instanceof LiveList) {
    if (model.roomId) {
      // If it's a model fetched from LB, we need to clone it
      // to avoid `Cannot attach node: already attached` and similar errors.
      // Update: model.clone() wasn't sufficient, because historically,
      // before introducing schema versioning, we saved deeply
      // nested properties as normal objects and we want to deeply recursively
      // re-wrap them in LiveObject/LiveList, not only clone the faulty structure.
      return wrapWithLiveblocksModel(model.toImmutable())
    }

    // If it's a fresh LB model, we can just insert it in the LB tree as is
    return model
  }

  if (model == null) return model

  // Handle arrays - wrap with LiveList
  if (Array.isArray(model)) {
    return new LiveList(
      model.map((item) => wrapWithLiveblocksModel(item)) as Lson[],
    )
  }

  // Handle objects - wrap with LiveObject
  if (typeof model === "object") {
    const wrappedObject = {}
    for (const [key, value] of Object.entries(model)) {
      // @ts-expect-error dynamic key iterating
      wrappedObject[key] = wrapWithLiveblocksModel(value)
    }
    return new LiveObject(wrappedObject)
  }

  // Return primitive values as-is
  return model
}
